import * as searchActions from '../../actions/search.actions';
import { SearchActions } from '../../actions/search.actions';
import { Chip, ReportItem } from "../../store.types";
import { createReducer } from "typesafe-actions";
import {WorkPackage} from "../../../models/responses/work-package.model";
import {FunctionModel} from "../../../models/responses/function.model";

export class SearchParametersModel {
    alert = false;
    taskForces: ([string, string])[] = [];
    taskOwner: any[] = [];
    chipList: Chip[] = [];
    searchText = ''
    startDate: number | null = null;
    finishDate: number | null = null;
    includeMilestones = false;
    noTaskForce = false;
    workPackage: WorkPackage | null = null;
    function: FunctionModel | null = null;
}

export class StateModel {
    searchValue = '';
    loading = false;
    chipsList: Chip[] = [];
    reportList: ReportItem[] = [];
    parameters = new SearchParametersModel();
    mapSearchText = '';
}

export const reducer = createReducer<StateModel, searchActions.Actions>(new StateModel())
    .handleAction(SearchActions.setSearchValue, (state, action) => ({
        ...state,
        parameters: {
            ...state.parameters,
            searchText: action.payload.toLowerCase()
        }
    }))
    .handleAction(SearchActions.setReportList, (state, action) => ({
        ...state,
        reportList: action.payload
    }))
    .handleAction(SearchActions.setTaskforceFilter, (state, action) => {
        return {
            ...state,
            parameters: {
                ...state.parameters,
                taskForces: action.payload,
                noTaskForce: false
            }
        }
    })
    .handleAction(SearchActions.setTaskOwnerFilter, (state, action) => ({
        ...state,
        parameters: {
            ...state.parameters,
            taskOwner: action.payload
        }
    }))
    .handleAction(SearchActions.removeIdFromTaskforecFilter, (state, action) => {
        const removeIndexes = action.payload.map(el => state.parameters.taskForces.findIndex(id => id[0] === el));
        const newArr = [...state.parameters.taskForces];

        removeIndexes.forEach(el => {
            newArr.splice(el, 1);
        });

        return {
            ...state,
            parameters: {
                ...state.parameters,
                taskForces: [...newArr]
            }
        };
    })
    .handleAction(SearchActions.removeTaskOwnerFilter, (state, action) => ({
        ...state,
        parameters: {
            ...state.parameters,
            taskOwner: []
        }
    }))
    .handleAction(SearchActions.toggleAlert, (state, action) => ({
        ...state,
        parameters: {
            ...state.parameters,
            alert: !state.parameters.alert
        }
    }))
    .handleAction(SearchActions.setSearchBarLoading, (state, action) => ({
        ...state,
        loading: action.payload
    }))
    .handleAction(SearchActions.addChip, (state, action) => ({
        ...state,
        parameters: {
            ...state.parameters,
            chipList: [...state.parameters.chipList, ...action.payload],
            includeMilestones: true
        }
    }))
    .handleAction(SearchActions.removeChip, (state, action) => {
        const newChipArr = [...state.parameters.chipList];
        const removeChipIndex = newChipArr.findIndex(el => el.text.toLowerCase() === action.payload.toLowerCase());

        newChipArr.splice(removeChipIndex, 1);

        return {
            ...state,
            parameters: {
                ...state.parameters,
                chipList: [...newChipArr]
            }
        }
    })
    .handleAction(SearchActions.removeAllChip, (state, action) => {
        return {
            ...state,
            parameters: {
                ...state.parameters,
                chipList: []
            }
        }
    })
    .handleAction(SearchActions.setReport, (state, action) => {
        return {
            ...state,
            parameters: {
                ...state.parameters,
                ...action.payload
            }
        }
    })
    .handleAction(SearchActions.setStartDate, (state, action) => {
        return {
            ...state,
            parameters: {
                ...state.parameters,
                startDate: action.payload
            }
        }
    })
    .handleAction(SearchActions.setFinishDate, (state, action) => {
        return {
            ...state,
            parameters: {
                ...state.parameters,
                finishDate: action.payload
            }
        }
    })
    .handleAction(SearchActions.setMapSearchText, (state, action) => {
        return {
            ...state,
            mapSearchText: action.payload
        }
    })
    .handleAction(SearchActions.resetAllFilters, (state, action) => {
        return {
            ...state,
            parameters: new SearchParametersModel(),
            mapSearchText: '',
            chipsList: [],
            loading: false,
            searchValue: '',
            reportList: [],
            workPackage: null,
            function: null
        }
    })
    .handleAction(SearchActions.setIncludeMilestones, (state, action) => {
        return {
            ...state,
            parameters: {
                ...state.parameters,
                includeMilestones: action.payload
            }
        }
    })
    .handleAction(SearchActions.setNoTaskForceFilter, (state, action) => {
        return {
            ...state,
            parameters: {
                ...state.parameters,
                noTaskForce: action.payload,
                taskForces: action.payload ? [] : state.parameters.taskForces
            }
        }
    })
    .handleAction(SearchActions.setWorkPackage, (state, action) => {
        return {
            ...state,
            parameters: {
                ...state.parameters,
                workPackage: action.payload
            }
        }
    })
